import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Remote.css";

const DataLogger = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    equipmentButtons,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    commands,
    devices,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
    // setSelectedEquipment({
    //   id: eq_id,
    //   type: eq_type,
    // });
  }, [equipmentButtons, equipment_id]);

  const calculateCRC16Modbus = (dataArray) => {
    let crc = 0xffff;

    for (let i = 0; i < dataArray.length; i++) {
      crc ^= dataArray[i];
      for (let j = 0; j < 8; j++) {
        if ((crc & 0x0001) !== 0) {
          crc = (crc >> 1) ^ 0xa001;
        } else {
          crc = crc >> 1;
        }
      }
    }

    const lowByte = crc & 0xff;
    const highByte = (crc >> 8) & 0xff;

    return [lowByte, highByte]; // خروجی: [Low, High]
  };
  const handleClickSingleCoil = (button_id, state) => {
    setSelectedButton({
      button_id: button_id,
      value: state,
    });
  };

  const handleChangeSingleRegisterValue = (button, value) => {
    if (isNaN(value)) {
      value = 0;
    }
    if (Number(value) * button.data5 > 65535) {
      value = Math.floor(65535 / button.data5);
    } else if (Number(value) * button.data5 > 65535 < 0) {
      value = 0;
    }
    // setSingleRegisterValues((prev) => ({
    //   ...prev,
    //   [button.id]: value,
    // }));

    setSelectedButton({
      button_id: button.id,
      value,
    });
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.button_id);
    let data1 = button.digit;
    let data2 = button.data1;
    let data3 = button.data2;
    let data4 = button.data3;
    let data5 = null;
    let data6 = null;
    let data7 = null;
    let data8 = null;
    let data9 = null;
    let data10 = null;
    let data11 = null;
    if (button.data1 == 5) {
      data5 = selectedButton.value;
      let crcVal = calculateCRC16Modbus([data1, data2, data3, data4, data5]);
      data6 = crcVal[0];
      data7 = crcVal[1];
    } else if (button.data1 == 6) {
      data5 = ((selectedButton.value * button.data5) >> 8) & 0xff;
      data6 = (selectedButton.value * button.data5) & 0xff;
      let crcVal = calculateCRC16Modbus([
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
      ]);
      data7 = crcVal[0];
      data8 = crcVal[1];
    }
    if (scenarioCommandDetail.id) {
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: data1,
                data2: data2,
                data3: data3,
                data4: data4,
                data5: data5,
                data6: data6,
                data7: data7,
                data8: data8,
                data9: data9,
                data10: data10,
                data11: data11,
                command_name: String(button.name),
                icon: button.icon ?? 1,
              }
            : command
        )
      );
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    } else {
      // setIsLoading(true);
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: data1,
          data2: data2,
          data3: data3,
          data4: data4,
          data5: data5,
          data6: data6,
          data7: data7,
          data8: data8,
          data9: data9,
          data10: data10,
          data11: data11,
          command_name: String(button.name),
          icon: button.icon ?? 1,
          device_id: button.device_id,
          time: 500,
        },
      ]);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    }
    setSelectedButton(null);
  };

  const renderThirdBox = () => {
    return buttons.map((button) => {
      if (button.data1 == 5) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        return (
          <div
            className="remote rounded"
            style={{
              width: "100px",
              boxShadow:
                selectedButton && selectedButton.button_id === button.id
                  ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                  : "none",
            }}
            key={button.id}
          >
            <div className="d-flex flex-wrap w-100">
              <div className="on-key w-50 p-1">
                <img
                  src="/assets/img/app-icons/on-key.png"
                  className="w-100"
                  alt="روشن"
                  onClick={() => handleClickSingleCoil(button.id, 1)}
                />
              </div>
              <div className="off-key w-50 p-1">
                <img
                  src="/assets/img/app-icons/off-key.png"
                  className="w-100"
                  alt="خاموش"
                  onClick={() => handleClickSingleCoil(button.id, 0)}
                />
              </div>
            </div>
            <div
              className={
                selectedButton &&
                selectedButton.button_id == button.id &&
                selectedButton.value == 1
                  ? "status-part bg-success"
                  : selectedButton &&
                    selectedButton.button_id == button.id &&
                    selectedButton.value == 0
                  ? "status-part bg-danger"
                  : "status-part"
              }
            ></div>
            <p className="m-0 p-0 text-center">{button.name}</p>
            <p className="text-center w-100" style={{ fontSize: "11px" }}>
              S/{devices.find((d) => d.id == button.device_id).serial}/
              {button.digit}/{(button.data2 << 8) | button.data3}{" "}
            </p>
          </div>
        );
      }
    });
  };

  const renderFourthBox = () => {
    return buttons.map((button) => {
      if (button.data1 == 6) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        return (
          <div
            className="row mt-3 py-2 mx-2"
            style={{
              boxShadow:
                selectedButton && selectedButton.button_id == button.id
                  ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                  : "",
            }}
            dir="ltr"
          >
            <label
              for="html5-text-input"
              className="col-sm-4 col-form-label text-end text-sm-center"
            >
              <p className="m-0 p-0">{button.name}</p>
              S/{devices.find((d) => d.id == button.device_id).serial}/
              {button.digit}/{(button.data2 << 8) | button.data3}
            </label>
            <div className="col-sm-8">
              <div className="d-flex flex-wrap justify-content-evenly">
                <div className="d-flex align-items-center justify-content-end">
                  <input
                    className="form-control mt-1"
                    style={{ width: "100%", maxWidth: "10rem" }}
                    placeholder="مقدار"
                    type="text"
                    value={
                      selectedButton && selectedButton.button_id == button.id
                        ? selectedButton.value
                        : ""
                    }
                    onChange={(e) =>
                      handleChangeSingleRegisterValue(button, e.target.value)
                    }
                    id="html5-text-input"
                  />
                  <i className="bx bx-x"></i>
                  <span> {button.data5} </span>
                  {selectedButton && selectedButton.button_id == button.id ? (
                    <span>
                    = {" "}
                      {!isNaN(button.data5 * selectedButton.value)
                        ? button.data5 * selectedButton.value
                        : 0}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  return (
    <div
      className="card h-100 w-100"
      // style={{ backgroundColor: "#fff0", boxShadow: "none" }}
       style={{backgroundColor: 'transparent', boxShadow: 'unset'}}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1", top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar mt-4 mx-auto w-100">
        {/* {buttons.filter((btn) => btn.data1 === 1 || btn.data2 === 2).length >
          0 && (
          <div class="card mt-2">
            <div className="card-body pb-2" style={{ position: "relative" }}>
              <div className="d-flex flex-wrap">{renderFirstBox()}</div>
            </div>
          </div>
        )} */}
        {/* {buttons.filter((btn) => btn.data1 === 3 || btn.data1 === 4).length >
          0 && (
          <div class="card mt-2">
            <div class="card-body pb-2" style={{ position: "relative" }}>
              <div class="table-responsive text-nowrap">
                <table class="table">
                  <thead>
                    <tr>
                      <th>نام</th>
                      <th>مقدار</th>
                    </tr>
                  </thead>
                  <tbody class="table-border-bottom-0">
                    {renderSecondBox()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )} */}

        {buttons.filter((btn) => btn.data1 === 5).length > 0 && (
          <div className="card mt-2 ">
            <div className="card-body pb-2" style={{ position: "relative" }}>
              <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">
                {renderThirdBox()}
              </div>
            </div>
          </div>
        )}

        {buttons.filter((btn) => btn.data1 === 6).length > 0 && (
          <div className="card mt-2 mb-3">
            <div className="card-body pb-2" style={{ position: "relative" }}>
              {renderFourthBox()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(DataLogger);
//
